import { useMutation } from '@tanstack/react-query';
import { UpdateLineItemsParams, updateRenewalLine } from './updateRenewalLine';
import { invalidateRenewalLines } from './useRenewals';
import { ErrorResponse, globalError } from '../../../store/notifications/actions';
import { RenewalLineOut } from '../../../store/api';
import { useDispatch } from 'react-redux';
import { invalidateManageRenewalsTotals } from './useManageRenewalsTotals';

export const useRenewalLineUpdateMutation = () => {
    const dispatch = useDispatch();

    return useMutation<RenewalLineOut, ErrorResponse, UpdateLineItemsParams, unknown>(updateRenewalLine, {
        onSuccess: () => {
            invalidateRenewalLines().then();
            invalidateManageRenewalsTotals().then();
        },
        onError: err => {
            dispatch(globalError(err));
        }
    });
};
